import * as React from 'react';
import { Route } from 'react-router-dom';

import { CallbackRequest } from '@root/components/www/callback_request';
import { Company } from '@root/components/www/company';
import { Help } from '@root/components/www/help';
import { Home } from '@root/components/www/home';
import { Legal } from '@root/components/www/legal';
import { Partnerships } from '@root/components/www/partnerships';

import { ErrorBoundary } from '@shared/error_boundary';
import { SwitchWithSharedRoutes } from '@shared/switch_with_shared_routes';

import { Guide } from '../../components/www/guide';

export const Routes: React.FC = () => {
  return (
    <ErrorBoundary>
      <SwitchWithSharedRoutes>
        <Route path="/legal" component={Legal} />
        <Route path="/help" component={Help} />
        <Route path="/guide" component={Guide} />
        <Route path="/company" component={Company} />
        <Route path="/partnerships" component={Partnerships} />
        <Route path="/cr/:slug" component={CallbackRequest} />
        <Route path="/" exact={true} component={Home} />
      </SwitchWithSharedRoutes>
    </ErrorBoundary>
  );
};
